import type { AxiosError } from "axios";
import axios from "axios";

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const currentLanguage = localStorage.getItem("portal-externo-language") || "pt-BR";
    config.headers["Accept-Language"] = currentLanguage;

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

export default api;
